<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipList (click)="openFilterDialog(name, label, reportFormControl)">
    <mat-chip-row
      *ngFor="let item of reportFormControl.value"
      [removable]="removable && !item.required"
      (removed)="removeFilter(reportFormControl, item)"
      [disabled]="isDisabled"
    >
      {{ item.title }}
      <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-row>
    <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
  </mat-chip-grid>
  <ui-svg-icon *ngIf="reportFormControl?.value?.length < 2" [name]="iconNameList.ListView" matSuffix></ui-svg-icon>
</mat-form-field>
